import React, { useEffect, useState } from 'react';
import logo from '../images/logo.svg';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isSidebarOpen ? 'hidden' : '';
  }, [isSidebarOpen]);

  const sidebarVariants = {
    hidden: { x: '-100%' },
    visible: { x: 0 },
    exit: { x: '-100%' },
  };

  return (
    <header className="py-4 transition-colors duration-300">
      <div className="container lg:px-10 px-6 max-w-[1600px] mx-auto">
        <div className="flex justify-between items-center">
          <div className="flex items-center md:w-auto w-full justify-between">
            <a href="/">
              <img src={logo} alt="Logo" className="h-12 w-auto" />
            </a>
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="md:hidden text-white focus:outline-none"
            >
              <Menu size={28} />
            </button>
          </div>

          <ul className="text-[rgb(227,228,233)] md:flex gap-x-8 items-center hidden">
            <li><a className="hover:text-white duration-200 text-base" href="/">Home</a></li>
            <li><a className="hover:text-white duration-200 text-base" href="/solutions">Solutions</a></li>
            <li><a className="hover:text-white duration-200 text-base" href="/about-us">About Us</a></li>
            <li><a className="hover:text-white duration-200 text-base" href="/blog">Blog</a></li>
            <li><a className="hover:text-white duration-200 text-base" href="/contact">Contact</a></li>
          </ul>

          <div className="hidden md:block">
            <a
              href="/contact"
              className="transition-colors duration-300 group inline-flex items-center outline-none relative justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-[34px] text-[15px] px-[26px] rounded-full text-gray-94 shadow-[0px_3px_7.2px_0px_rgba(10,10,10,0.20)] dark:shadow-[0px_3px_7.2px_0px_rgba(10,10,10,0.80)] font-semibold"
            >
              <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#6d6d7f_0%,#292C3D_50%,#17181C_100%)] transition-opacity duration-200 group-hover:opacity-0"></span>
              <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#9999B3_0%,#4D4D5B00_100%)] opacity-0 transition-opacity duration-200 group-hover:opacity-100"></span>
              <span className="absolute inset-0 rounded-full bg-[#16171D]"></span>
              <span className="absolute inset-0 rounded-full bg-[radial-gradient(195.27%_60.29%_at_50%_60.29%,_rgba(6,6,9,0.00)_0%,_#25252D_100%)] transition-opacity duration-200 group-hover:opacity-0"></span>
              <span className="absolute inset-0 rounded-full bg-[radial-gradient(99.73%_74.81%_at_49.59%_-33.82%,_#8D91A5_0%,_rgba(141,145,165,0.30)_49%,_rgba(29,30,37,0.00)_100%),_radial-gradient(195.27%_60.29%_at_50%_60.29%,_rgba(6,6,9,0.00)_0%,_#25252D_100%)] opacity-0 transition-opacity duration-200 group-hover:opacity-100"></span>
              <span className="relative z-20 text-[rgb(227,228,233)]">Get in touch</span>
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex md:hidden"
          >
            <div
              className="absolute inset-0 bg-black/50"
              onClick={() => setIsSidebarOpen(false)}
            ></div>

            <motion.div
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={sidebarVariants}
              transition={{ type: 'tween', duration: 0.3 }}
              className="relative z-50 w-[250px] h-full bg-[#16171D] p-6 shadow-lg"
            >
              <div className="flex justify-between items-center mb-6">
                <img src={logo} alt="Logo" className="h-10" />
                <button
                  onClick={() => setIsSidebarOpen(false)}
                  className="text-white"
                >
                  <X size={24} />
                </button>
              </div>
              <ul className="text-white space-y-4">
                <li>
                  <a href="/" className="text-base block hover:text-gray-300 border-b border-b-[#fff]/10 pb-2">Home</a>
                </li>
                <li>
                  <a href="/solutions" className="text-base block hover:text-gray-300 border-b border-b-[#fff]/10 pb-2">Solutions</a>
                </li>
                <li>
                  <a href="/about-us" className="text-base block hover:text-gray-300 border-b border-b-[#fff]/10 pb-2">About Us</a>
                </li>
                <li>
                  <a href="/blog" className="text-base block hover:text-gray-300 border-b border-b-[#fff]/10 pb-2">Blog</a>
                </li>
                <li>
                  <a href="/contact" className="text-base block hover:text-gray-300 border-b border-b-[#fff]/10 pb-2">Contact</a>
                </li>
                <li>
                  <a
                    href="/contact"
                    className="mt-4 inline-block text-sm px-4 py-2 rounded-full bg-gradient-to-b from-[#6d6d7f] to-[#17181C] text-white"
                  >
                    Get in touch
                  </a>
                </li>
              </ul>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
